import { render } from "./DeviceCard.vue?vue&type=template&id=9be0fab4&ts=true"
import script from "./DeviceCard.vue?vue&type=script&lang=ts"
export * from "./DeviceCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__